import Box from '../../Atomics/Box';
import { StyledButton } from '../../Atomics/Button';
import { Heading } from '../../Atomics/Heading';
import CustomIcon from '../../Icons/CustomIcon';

import * as IconsLibrary from '../../Icons/Library';

type TProps = {
    icon?: IconsLibrary.LibraryTypes;
    name: string;
    onClick?: () => void;
};

const CategoryBox = ({ icon, name, onClick }: TProps) => {
    return (
        <StyledButton width="100%" height="100%" py="sm" my="xs" onClick={onClick}>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems={icon ? 'flex-start' : undefined}
                width="100%"
                height="100%"
                bg="white"
                boxShadow="level2"
                borderRadius="lg"
                p="md"
            >
                {icon && <CustomIcon icon={icon} customColor="black-1" />}
                <Heading level={1} typography="text-s-bold" customColor="black-1" textAlign={!icon ? 'center' : 'left'} mt={icon ? 'md' : undefined}> {name} </Heading>
            </Box>
        </StyledButton>
    );
};

export default CategoryBox;
